import { memo } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
import { typographyPresets } from '@/design-system/typography';
import DrawerHeaderStyled from './DrawerHeaderStyled';
import logo from '@/assets/FamilyErpLogoLight-128.webp';

interface DrawerHeaderProps {
  open: boolean;
}

const DrawerHeader = memo<DrawerHeaderProps>(function DrawerHeader({ open }) {
  const theme = useTheme();

  return (
    <DrawerHeaderStyled theme={theme} open={open}>
      <Link
        href="/dashboard"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: open ? 'flex-start' : 'center',
          gap: 1.5,
          textDecoration: 'none',
          width: '100%',
          px: open ? 1.5 : 0,
          py: 1,
          borderRadius: '14px',
          transition: 'all 0.2s ease-in-out',
          bgcolor: open ? 'rgba(255, 255, 255, 0.04)' : 'transparent',
          border: open
            ? '1px solid rgba(255, 255, 255, 0.08)'
            : '1px solid transparent',
          '&:hover': {
            bgcolor: open ? 'rgba(255, 255, 255, 0.06)' : 'transparent',
            '& .logo-text': {
              color: '#1ABC55',
            },
          },
        }}
      >
        {/* Logo Icon */}
        <Box
          sx={{
            width: open ? 42 : 36,
            height: open ? 42 : 36,
            borderRadius: '10px',
            bgcolor: 'rgba(26, 188, 85, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            transition: 'all 0.2s ease-in-out',
          }}
        >
          <img
            src={logo}
            alt="Family ERPS"
            width={128}
            height={128}
            style={{
              height: open ? '32px' : '26px',
              width: 'auto',
              objectFit: 'contain',
              transition: 'all 0.2s ease-in-out',
            }}
          />
        </Box>

        {/* Company Name - Only show when drawer is open */}
        {open && (
          <Box sx={{ overflow: 'hidden' }}>
            <Typography
              className="logo-text"
              sx={{
                ...typographyPresets.subheading1,
                color: '#ffffff',
                lineHeight: 1.2,
                transition: 'color 0.2s ease-in-out',
                whiteSpace: 'nowrap',
              }}
            >
              Family ERPS
            </Typography>
            <Typography
              sx={{
                ...typographyPresets.caption,
                color: 'rgba(255, 255, 255, 0.5)',
                lineHeight: 1.2,
                whiteSpace: 'nowrap',
              }}
            >
              Enterprise Portal
            </Typography>
          </Box>
        )}
      </Link>
    </DrawerHeaderStyled>
  );
});

DrawerHeader.displayName = 'DrawerHeader';

export default DrawerHeader;
